import { create } from "@cohub42/lib/zustand";

interface TWaitListStore {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  onCloseModal: () => void;
}

export const useWaitListStore = create<TWaitListStore>((set) => ({
  showModal: false,
  setShowModal: (showModal) => set(() => ({ showModal })),
  onCloseModal: () => set(() => ({ showModal: false })),
}));
